import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { moduleActions } from '../../../../redux/modules';
import StepExpanded from '../../../Shared/StepExpanded/StepExpanded';
import { getFilteredRothConversionFromFundsList } from '../../../../redux/modules/rothConversionTransaction/rothConversionTransaction.selectors';
import RothConversionNote from './RothConversionNote';
import './RothConversionFromForm.scss';
import ExpandedFundList from '../../../Buy/BuyFlow/ExpandedFundList/ExpandedFundList';
import RothConversionFundEditor from '../../common/RothConversionFundEditor/RothConversionFundEditor';
import config from 'src/config/config';

const RothConversionFromForm = ({
  step,
  onSelectFund,
  handleFundAllocations,
  actions,
  customerWebViewEnabled,
  isSalesforceRep,
}) => {
  //redux
  const dispatch = useDispatch();
  const { openModal } = moduleActions;
  const openModalAction = useCallback(
    (...arg) => dispatch(openModal(...arg)),
    [dispatch, openModal]
  );
  const userFunds = useSelector(getFilteredRothConversionFromFundsList);
  return (
    <StepExpanded className="rothconvert-from-form">
      <div className="rothconversion-contact-us">
        <div>
          Roth IRA(s) will keep the same fund selection and allocation as the
          IRA(s) chosen for conversion. If you would like your Roth IRA invested
          in a different fund, you may use our{' '}
          <a href={`${config.url}/usis/transactions/exchange`} rel="noreferrer">
            Exchange Flow
          </a>{' '}
          either prior to or after the conversion. {' '}
        </div>
      </div>
      <div className="traditional">Traditional and Rollover IRAs</div>
      <div className="rothconvert-from-form-fund-list">
        <ExpandedFundList
          actions={{
            ...actions,
            selectFund: onSelectFund,
            deselectFund: onSelectFund,
          }}
          showAddNewFundOrAccountEvenIfEmpty={false}
          currentStep={step}
          availableFunds={userFunds || []}
          numberOfFunds={userFunds.length}
          onSelectFund={onSelectFund}
          fundEditor={() => RothConversionFundEditor}
          handleFundAllocations={handleFundAllocations}
          isManySelect={true}
          openModal={openModalAction}
          personalData={{}}
          priorYearInclusiveRemainingContributions={null}
          quickBuy={{}}
          shoppingCart={{}}
          isSalesforceRep={isSalesforceRep}
        />
      </div>
      <div className="rothconvert-from-form_allocation" />
      <RothConversionNote
        customerWebViewEnabled={customerWebViewEnabled}
        isSalesforceRep={isSalesforceRep}
      />
    </StepExpanded>
  );
};

export default RothConversionFromForm;
